

import React from 'react';

export default function Footer() {
    return (
       <>

       <section class="position-relative z-1">
            
            <div class="try_box text-center">
                <h3 class="try_boxsub">Ready to start your project?</h3>
                
                <a href="https://www.syncloop.ai/deploy-on-docker.html" target="_blank" class="try_boxbutton">
                 Try on Docker <img src="https://www.syncloop.ai/assets/img/tryright.svg" /></a>
            </div>    
        </section> 
            
        {/* FOOTER */}
        <div className="aiart-footer bgc-background pt-120">
            <div className="aiart-footer-top">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-xl-2 col-lg-5">
                            <div className="footer-single-col">
                                <img src="/assets/img/logo/syncloop-logobl.svg" alt="" />
                                <p className="flh-24 mt-0 mb-30">Visual experience-based workspace where you efficiently build, integrate & deploy Apps</p>                         
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-5">
                            <div className="footer-single-col">
                                <h3 className="it-company-color">Explore The Platform</h3>
                                <ul className="list-unstyled footer-nav-list mb-lg-0">
                                    <li><a href="https://www.syncloop.ai" className="text-decoration-none">Home</a></li>
                                    
                                <li><a href="https://www.syncloop.ai/templates.html" className="text-decoration-none">Templates</a></li>
                                <li><a href="https://docs.syncloop.ai" target="_blank">Documentation</a></li>
                                 

                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-5">
                            <div className="footer-single-col pr-20">
                                <h3 className="it-company-color">Features</h3>
                                <ul className="list-unstyled footer-nav-list mb-lg-0">
                                     <li><a href="https://www.syncloop.ai/apps.html">Apps</a></li>
                                     <li><a href="https://www.syncloop.ai/multiselect.html">Teams</a></li>
                                     <li><a href="https://www.syncloop.ai/agents.html">Agents</a></li>
                                     <li><a href="https://www.syncloop.ai/llm.html">LLMs</a></li>
                                     <li><a href="https://www.syncloop.ai/tools.html">Tools</a></li>
                                    
                                </ul>
                          
                            </div>
                        </div>
                           <div className="col-xl-2 col-lg-5">
                            <div className="footer-single-col pr-20">
                                <h3 className="it-company-color">Resources</h3>
                                <ul className="list-unstyled footer-nav-list mb-lg-0">
                                    
                                     
                                     <li><a href="https://www.syncloop.ai/blogs.html">Blogs</a></li>                                    
                                     <li><a href="https://www.syncloop.ai/contact-us.html">Contact us</a></li>
                                </ul>
                               
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-5">
                            <div className="footer-single-col">
                                <h3 className="it-company-color">Communities and Social Media</h3>                               
                         
                                <ul className="list-unstyled social_icon list-inline footer-social-list mb-0">
                                    <li className="list-inline-item">
                                        <a  target="_blank" href="https://discord.com/invite/EnazFJpGQs?utm_source=Website&amp;utm_medium=click&amp;utm_id=discord&amp;utm_content=bottom">
                                        <img src="/assets/img/docs/discord.svg" />
                                        </a></li>
                                    <li className="list-inline-item"><a target="_blank" href="https://www.youtube.com/@syncloop">
                                    
                                         <img src="/assets/img/docs/utube.svg" /></a></li>
                                        <li className="list-inline-item"><a target="_blank" href="https://twitter.com/Syncloop_dev">
                                        
                                            <svg width="16" height="15" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8631 18.3333L8.23857 11.7418L2.44925 18.3333H0L7.15193 10.1926L0 0H6.28829L10.6468 6.21252L16.1079 0H18.5572L11.7371 7.76374L19.1514 18.3333H12.8631ZM15.5906 16.475H13.9417L3.50696 1.85833H5.15612L9.33529 7.71097L10.058 8.72655L15.5906 16.475Z" fill="black"></path>
                                            </svg></a></li>
                                        <li className="list-inline-item"><a target="_blank" href="https://www.linkedin.com/company/syncloop/">
                                       <img src="/assets/img/docs/linkedin_icon.svg" /></a></li>
                                       <li class="list-inline-item"><a target="_blank" href="https://www.udemy.com/course/syncloop-ai/?referralCode=FE8BC4DE6B60DD9509C7"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="Udemy-Icon--Streamline-Svg-Logos" height="24" width="24">                       
                                      <path fill="#a435f0" d="M18.05985 7.247975 11.998725 3.749 5.939325 7.247975V3.749L11.9996 0.25l6.0611 3.499v3.498975h-0.00085Z" stroke-width="0.25"></path>
                                      <path fill="#000000" d="M5.939325 10.186275h3.174625v7.71315c0 1.99275 1.488125 2.964125 2.88565 2.964125 1.4096 0 2.886475 -0.99725 2.886475 -2.990875V10.186275h3.174625v7.896875c0 1.835775 -0.577125 3.252275 -1.731375 4.22365 -1.1551 0.9705 -2.5975 1.44325 -4.356475 1.44325 -1.757275 0 -3.2005 -0.4719 -4.328025 -1.44325 -1.128375 -0.9705 -1.7055 -2.3344 -1.7055 -4.145125V10.186275Z" stroke-width="0.25"></path>
                                    </svg></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rm-footer-bottom text-center">
                <div className="container">
                    <div className="copyright">
                    <div className="row">
                        <div className="col-md-6">
                             <div className="text-center text-md-start copyright-text">
                                © 2025 Syncloop AI - Nature9 Inc. All rights reserved.
                            </div>
                        </div>
                        <div className="col-md-6">
                              <div className="text-center text-md-end  copyright-text">
                                <a href="https://www.syncloop.ai/terms-conditions.html">Terms & Conditions</a> ~ <a href="https://www.syncloop.ai/privacy-policy.html">Privacy Policy</a>
                            </div> 
                        </div>    
                    </div>    
                   </div>
                     
                        
                </div>
                
            </div>
        </div>
         </>
    );
}
